import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Button, Menu, Row } from 'antd';
import { NextPage } from 'next';
import { FormattedMessage } from 'react-intl';
import { ChallengedTabsEnum } from 'src/shared/enums';

interface OwnProps {
  pageClassName: string;
  filterComponent: JSX.Element;
  tabs: {
    key: ChallengedTabsEnum;
    label: string;
  }[];
  onChangeTab: (key: number) => void;
  renderChallenges: () => JSX.Element | JSX.Element[];
  showMoreComponent: JSX.Element;
}

const BuildPageChallenge: NextPage<OwnProps> = ({
  pageClassName,
  filterComponent,
  tabs,
  onChangeTab,
  renderChallenges,
  showMoreComponent,
}): JSX.Element => {
  return (
    <div className={`container challengePage ${pageClassName}`}>
      {filterComponent}
      <div id="hided-by-filter" className="challengePage__filtersForm">
        <Menu
          onClick={(e) => onChangeTab(Number(e.key))}
          defaultSelectedKeys={[String(tabs[0].key)]}
          mode="horizontal"
        >
          {tabs.map((tab) => (
            <Menu.Item key={tab.key}>
              <span className="regular-body">
                <FormattedMessage id={tab.label} />
              </span>
            </Menu.Item>
          ))}
        </Menu>
      </div>

      <Row
        className="challengePage__challenges-row"
        justify="start"
        gutter={[12, 24]}
        children={renderChallenges()}
      />

      {showMoreComponent}
    </div>
  );
};

export default BuildPageChallenge;

export const showMoreButton = (
  label: string,
  isLoading: boolean,
  hasMore: boolean,
  fetch: () => Promise<void>
): JSX.Element => {
  if (isLoading) return <LoadingOutlined />;

  return (
    hasMore && (
      <Row justify="center" style={{ padding: '1cm 0' }}>
        <Button
          className="show-more btn-ghost btn-ghost--minimalist remove-right-space"
          loading={isLoading}
          onClick={fetch}
        >
          <Row justify="center" align="middle">
            <p>
              <FormattedMessage id={label} />
            </p>
            <a className={`icon icon--arrow-dropdown-down icon__reduce_75`} />
          </Row>
        </Button>
      </Row>
    )
  );
};
